module.exports = __webpack_public_path__ + "static/Spork-c1edd5636bf7d8966a5f6f15c1385dd1.jpg";